// 导入封装好的 axios 实例
import request from '@/utils/request'


//登录接口
export function login(data) {
    return request({
        url: '/oauth/account/login',
        method: 'post',
        data
    })
}
//公钥
export function getPublicKey(data) {
    return request({
        url: '/oauth/rsa/public-key',
        method: 'get',
        data
    })
}
